/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxAlignBottomRightFilled = createReactComponent(
  "box-align-bottom-right-filled",
  "IconBoxAlignBottomRightFilled",
  [
    [
      "path",
      {
        d: "M19 12h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-1",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-2",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-3",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-4",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M9 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-5",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-6",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-7",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M4 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-8",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M4 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-9",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconBoxAlignBottomRightFilled as default };
//# sourceMappingURL=IconBoxAlignBottomRightFilled.js.map
